import React from "react";
import { Link } from "react-router-dom";
import { ModuleName, PageRoute } from "../../../../models";
import { getIconUrl } from "../../../../services/asset";
import styles from "./popularCategory.scss";
import { formatNumber, stringifyURI } from "../../../../services";
import { AdsSortOption, QueryParam } from "../../../../models/enums";

const PopularCategory = ({ popular }) => {
  // Routes come with the popular item (moduleRoute / categoryRoute); a tile
  // without a category links to the module.
  const getPopularLink = (popularCate: any) => {
    const moduleRoute = popularCate.moduleRoute;
    const categoryRoute = popularCate.categoryRoute;

    if (!popularCate.category || !categoryRoute) {
      return `/${moduleRoute}`;
    }

    if (popularCate.module == ModuleName.vehicles) {
      return `/${moduleRoute}/${categoryRoute}`;
    } else if (popularCate.module == ModuleName.realEstate) {
      return `/${moduleRoute}/${categoryRoute}${stringifyURI({
        category: categoryRoute
      }, QueryParam.searchQuery)}`;
    } else if (popularCate.module == ModuleName.tourism) {
        return `/${moduleRoute}/${categoryRoute}${
          PageRoute.search
        }${stringifyURI({
          module: moduleRoute,
          category: categoryRoute,
          sortOption: AdsSortOption.DateDesc
        }, QueryParam.searchQuery)}`;
    }

    return `/${moduleRoute}`;
  };

  const returnSingularOrPlural = count => {
    if (String(count).slice(-2) == "11") {
      return "oglasa";
    } else if (String(count).slice(-1) == "1") {
      return "oglas";
    } else {
      return "oglasa";
    }
  };

  return (
    <Link
      to={getPopularLink(popular)}
      className={styles.popularItem}
      style={{
        background: `linear-gradient(0.15turn, ${popular.gradientFrom}, ${popular.gradientTo})`
      }}
    >
      <img
        className={styles.popularImage}
        alt={popular.displayName}
        src={getIconUrl(`${popular.category || popular.module}.svg`)}
      />
      <span className={styles.popularDisplayName}>{popular.displayName}</span>
      <span className={styles.count}>
        {formatNumber(popular.count)} {returnSingularOrPlural(popular.count)}
      </span>
    </Link>
  );
};

PopularCategory.defaultProps = {
  className: ""
};

export default PopularCategory;



// WEBPACK FOOTER //
// ./src/containers/HomePage/PopularCategories/PopularCategory/PopularCategory.tsx